/** Optional lower admission ceilings for untrusted server uploads. Normal project
 * loading keeps existing limits. These cap expansion, not full process RSS. */
export interface ProjectDecodeLimits {
  currentVersionOnly?: boolean;
  tiles?: number;
  tileBytes?: number;
  runtimeEdges?: number;
  runtimeBindings?: number;
  runtimeIdentityUnits?: number;
  scalarParts?: number;
  scalarText?: number;
}
export function lowerDecodeLimit(value: number | undefined, ceiling: number) {
  if (value === undefined) return ceiling;
  if (!Number.isSafeInteger(value) || value < 1 || value > ceiling)
    throw new RangeError('Invalid project decoding limit');
  return value;
}
